/* eslint-disable complexity */
/* eslint-disable no-empty */
import { VSF_LOCALE_COOKIE, VSF_CURRENCY_COOKIE } from '@vue-storefront/core';
const cookie = require("cookie");

// eslint-disable-next-line complexity
const seriCookie = (cookieObject) => {
  const cookieStrings = [];
  for (const key in cookieObject) {
    const serializedCookie = cookie.serialize(key, cookieObject[key]);
    cookieStrings.push(serializedCookie);
  }
  return cookieStrings.join("; ");
};
function getCookies(cookieString) {
  const cookieObj = {};
  if (cookieString) {
    const cookies = cookieString.split('; ');
    if (cookies) {
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');
        cookieObj[decodeURIComponent(cookie[0])] = decodeURIComponent(cookie[1]);
      }
    }
  }

  return cookieObj;
}
export default async (ctx) => {
  const { app, $vsf, $gtm, req, res, route, $cookies, error } = ctx;
  if (route.query.debug) {
    $cookies.set("debug", 1, {
      path: "/",
      sameSite: "Lax",
      maxAge: 3600 * 24 * 365
    });
  }
  if (route.query.currency) {
    if (req?.headers.cookie) {
      const parsedCookies = getCookies(req.headers.cookie);
      parsedCookies[VSF_CURRENCY_COOKIE] = route.query.currency;
      req.headers.cookie = seriCookie(parsedCookies);
    }
    $cookies.set(VSF_CURRENCY_COOKIE, route.query.currency, {
      path: "/",
      sameSite: "Lax",
      maxAge: 3600 * 24 * 365
    });
  }
  if (process.server) {
    app.$xreq = {
      host: req?.headers.host,
      cookie: req?.headers.cookie
    };
  } else {
    app.$xreq = {
      host: window.location.host,
      cookie: document.cookie
    };
  }
  // debug参数
  const debug = $cookies.get("debug") || 0;

  app.$storeConfig = await $vsf.$xbuy.api.shopConfigAll({ host: app.$xreq.host, cache_key: process.env.clear_cache_uniqueKey, debug: debug });

  if (app.$storeConfig.error) {
    error({ statusCode: 500, message: app.$storeConfig.error });
    return;
  }
  if (app.$storeConfig?.mall_shouhou_config) {
    app.$storeConfig.mall_shouhou_config = JSON.parse(app.$storeConfig.mall_shouhou_config);
  } else {
    app.$storeConfig.mall_shouhou_config = {
      'showshouhou': '1',
      'checkout': '1'
    };
  }
  if (app.$storeConfig?.mall_registry_settings) {
    app.$storeConfig.mall_registry_settings = JSON.parse(app.$storeConfig.mall_registry_settings);
  } else {
    app.$storeConfig.mall_registry_settings = {
      "email": {
        "enable": true,
        "verify": false
      },
      "phone": {
        "enable": false,
        "verify": false
      }
    };
  }

  /** ***************************切换默认语言*********************************/
  const { data } = await $vsf.$xbuy.api.shopView({ debug: debug });
  const viewList = data?.list;
  if (viewList) {
    app.$viewList = viewList;
  }

  // req中的币种
  const currency = $cookies.get(VSF_CURRENCY_COOKIE);

  // 通过url中的语言获取视图
  let defaultView = viewList?.find((item) => {
    return (route.path.indexOf("/" + item.lang) > -1);
  });

  // 获取默认视图
  if (!defaultView) {
    defaultView = viewList?.find((item) => {
      return item.isDefault === 1;
    });
    // 如果route.path=/，则跳转到默认语言
    if ((route.path === '/' || route.path === '' || route.path.indexOf('/p/') !== -1 || route.path.indexOf('/a/') !== -1 || route.path.indexOf('/l/') !== -1) && defaultView) {
      return ctx.redirect(`/${defaultView.lang}${route.fullPath}`);
    }
  }
  // 给api请求设置cookie
  if (req && req.headers) {
    if (!req.headers.cookie) {
      const cookieObj = {
        [VSF_LOCALE_COOKIE]: defaultView?.lang,
        [VSF_CURRENCY_COOKIE]: currency || defaultView?.currency
      };
      req.headers.cookie = seriCookie(cookieObj);
    } else {
      if (req.headers.cookie.indexOf(VSF_LOCALE_COOKIE) === -1) {
        req.headers.cookie += `;${VSF_LOCALE_COOKIE}=${defaultView?.lang}`;
      }
      if (req.headers.cookie.indexOf(VSF_CURRENCY_COOKIE) === -1) {
        req.headers.cookie += `;${VSF_CURRENCY_COOKIE}=${currency || defaultView?.currency}`;
      }
    }
  }

  // 给浏览器设置cookie
  $cookies.set(VSF_LOCALE_COOKIE, defaultView?.lang, {
    path: "/",
    sameSite: "Lax",
    maxAge: 3600 * 24 * 365
  });
  app.defaultView = defaultView;
  // 优先使用浏览器cooke中的币种
  if (!currency) {
    $cookies.set(VSF_CURRENCY_COOKIE, defaultView?.currency, {
      path: "/",
      sameSite: "Lax",
      maxAge: 3600 * 24 * 365
    });
  }

  /** ***************************************************************/
  const ConfigAll = await $vsf.$xbuy.api.configAll({ lang: defaultView?.lang, debug: debug });
  if (ConfigAll) {
    app.$mallConfig = {};
    for (const key in ConfigAll) {
      if (ConfigAll[key].indexOf("{") === 0) {
        app.$mallConfig[key] = JSON.parse(ConfigAll[key]);
      } else {
        app.$mallConfig[key] = ConfigAll[key];
      }
    }
    if (!app.$mallConfig.mall_web_config) {
      app.$mallConfig.mall_web_config = {
        meta: [{ charset: 'utf-8' }, {
          content:
            "width=device-width, initial-scale=1",
          name:
            "viewport"
        }]
      };
    }
    if (app.$storeConfig?.mall_web_google_meta) {
      let meta;
      try {
        meta = JSON.parse(app.$storeConfig?.mall_web_google_meta);
      } catch (e) {
        meta = [];
      }
      app.$mallConfig.mall_web_config.meta = app.$mallConfig.mall_web_config?.meta?.concat(meta);
    }

    if (app.$storeConfig?.mall_web_bing_meta) {
      let meta;
      try {
        meta = JSON.parse(app.$storeConfig?.mall_web_bing_meta);
      } catch (e) {
        meta = [];
      }
      app.$mallConfig.mall_web_config.meta = app.$mallConfig.mall_web_config?.meta?.concat(meta);
    }
    // if (app.$storeConfig?.mall_cache_pre && debug) {
    //   app.$storeConfig.mall_cache_pre += '_' + debug;
    // }
    if (app.$storeConfig?.mall_web_baidu_meta) {
      let meta;
      try {
        meta = JSON.parse(app.$storeConfig?.mall_web_baidu_meta);
      } catch (e) {
        meta = [];
      }
      app.$mallConfig.mall_web_config.meta = app.$mallConfig.mall_web_config?.meta?.concat(meta);
    }
    if (app?.$mallConfig?.mall_currency) {
      const currency1 = $cookies.get(VSF_CURRENCY_COOKIE);
      const index = app.$mallConfig.mall_currency.indexOf(currency1);
      if (index === -1) {
        $cookies.set(VSF_CURRENCY_COOKIE, defaultView.currency, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 365
        });
      }
    }
  }

  if (process.client) {
    const googleParams = app.$storeConfig.mall_google_analytics;
    if (googleParams && googleParams.indexOf('gtmId') !== -1) {
      const gtmId = JSON.parse(googleParams).gtmId;
      $gtm.init((gtmId || "GTM-N9S4RQ5"));
    } else {
      $gtm.init((googleParams || "GTM-N9S4RQ5"));
    }
  }
};
